export default "https://cdn-static.gokick.com/assets/0ba7a9ad4dd7229a35aca69ca4183ecb31843a51/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";